// Microcopy Engine - Dynamic bilingual messaging system for KaizenOS
// Selects motivational messages based on user context

const SENTENCE_BANKS = {
  MAX_LEVEL: {
    headlines: {
      es: [
        "Nivel máximo. Ahora toca mantenerlo.",
        "100/100 — lo difícil es sostenerlo.",
        "Estás en la cima. Defiéndela.",
        "Forma top. Mantén el filo.",
        "Racha activa. No aflojes.",
        "Modo mantenimiento: ejecuta lo simple.",
        "Constancia > intensidad.",
        "Tu estándar está alto. Manténlo.",
        "Cima alcanzada. Que no se te escape.",
        "Momentum perfecto. No lo sueltes.",
        "Nivel leyenda. Sin confiarse.",
        "Excelente. Ahora protege tu ritmo.",
        "Estás fino. Mantente fino.",
        "Hoy: lo mínimo… pero hazlo.",
        "Disciplina visible. Sigue igual.",
        "Top tier. Mantén la ventaja.",
        "Dominio total. Sostén la racha.",
        "Máximo nivel: ahora es consistencia.",
        "Cero drama: solo constancia.",
        "En la cima, cada día cuenta."
      ],
      en: [
        "Max level. Now maintain it.",
        "100/100 — staying there is the real skill.",
        "You're at the top. Defend it.",
        "Peak form. Keep the edge.",
        "Streak active. Don't loosen up.",
        "Maintenance mode: execute the basics.",
        "Consistency beats intensity.",
        "Your standard is high. Keep it.",
        "Peak reached. Don't let it slip.",
        "Perfect momentum. Don't drop it.",
        "Legend level. No complacency.",
        "Great. Now protect your rhythm.",
        "You're dialed in. Stay dialed in.",
        "Today: minimal… but do it.",
        "Discipline shows. Keep going.",
        "Top tier. Keep the advantage.",
        "Full control. Protect the streak.",
        "Max level means consistency.",
        "No drama: just consistency.",
        "At the top, every day counts."
      ]
    },
    sublines: {
      es: [
        "Racha: {streakDays} días. Hoy solo mantenla viva.",
        "Llevas {hoursSinceLastOpen}h sin entrar. 2 minutos y sigues arriba.",
        "Hoy: {todayCompleted}/{todayTotal}. Cierra fuerte.",
        "Te faltan {daysToRecord} días para romper tu récord.",
        "Una micro-victoria hoy = cadena intacta.",
        "Si haces lo fácil hoy, mañana será más fácil.",
        "No busques perfecto: busca constante.",
        "La cima se defiende con lo básico.",
        "Dos minutos ahora ahorran cero excusas después.",
        "Mantén el ritmo: hoy cuenta."
      ],
      en: [
        "Streak: {streakDays} days. Keep it alive today.",
        "It's been {hoursSinceLastOpen}h. Two minutes keeps you on top.",
        "Today: {todayCompleted}/{todayTotal}. Close it out strong.",
        "You're {daysToRecord} days away from a new record.",
        "One tiny win today keeps the chain unbroken.",
        "Do the easy thing today; tomorrow gets easier.",
        "Don't chase perfect: chase consistent.",
        "The peak is defended by basics.",
        "Two minutes now saves excuses later.",
        "Hold the rhythm: today matters."
      ]
    }
  },

  HIGH_LEVEL: {
    headlines: {
      es: [
        "Vas muy alto. Mantén el impulso.",
        "Casi perfecto. Pulir detalles.",
        "Gran nivel. Sigue empujando.",
        "Ritmo fuerte. No lo rompas.",
        "Estás cerca del tope. Aprieta suave.",
        "Buen progreso. Hazlo repetible.",
        "Momentum real. Sosténlo.",
        "Vas en serio. Sigue.",
        "Gran racha. Cuídala.",
        "Estás construyendo algo sólido."
      ],
      en: [
        "You're very high. Keep the momentum.",
        "Almost perfect. Refine the details.",
        "Strong level. Keep pushing.",
        "Solid rhythm. Don't break it.",
        "Close to the top. Smooth push.",
        "Great progress. Make it repeatable.",
        "Real momentum. Hold it.",
        "You're serious. Keep going.",
        "Strong streak. Protect it.",
        "You're building something solid."
      ]
    },
    sublines: {
      es: [
        "Hoy: {todayCompleted}/{todayTotal}. Un empujón y listo.",
        "Racha: {streakDays} días. Sigue igual.",
        "Estás a {daysToRecord} días del récord. Vamos.",
        "Pequeño esfuerzo hoy, gran ventaja mañana.",
        "Hazlo simple para hacerlo diario."
      ],
      en: [
        "Today: {todayCompleted}/{todayTotal}. One push and done.",
        "Streak: {streakDays} days. Keep it steady.",
        "You're {daysToRecord} days from your record. Let's go.",
        "Small effort today, big edge tomorrow.",
        "Make it simple so it becomes daily."
      ]
    }
  },

  MID_LEVEL: {
    headlines: {
      es: [
        "Buen camino. Suma un poco hoy.",
        "Construyendo momentum.",
        "Progreso real. Sigue.",
        "Paso a paso, pero constante.",
        "Hoy cuenta. Hazlo fácil.",
        "Vas avanzando. No pares.",
        "Base sólida en construcción.",
        "Sigue apilando victorias pequeñas.",
        "Buen ritmo. Manténlo.",
        "Constancia: tu arma secreta."
      ],
      en: [
        "Good path. Add a bit today.",
        "Building momentum.",
        "Real progress. Keep going.",
        "Step by step, but consistent.",
        "Today matters. Keep it easy.",
        "You're moving. Don't stop.",
        "Solid base in progress.",
        "Stack small wins.",
        "Good rhythm. Keep it.",
        "Consistency: your secret weapon."
      ]
    },
    sublines: {
      es: [
        "Hoy: {todayCompleted}/{todayTotal}. Solo uno más.",
        "Racha: {streakDays} días. Sigue sumando.",
        "Haz lo mínimo viable hoy.",
        "Un hábito pequeño vence a una motivación grande.",
        "No busques épico: busca constante."
      ],
      en: [
        "Today: {todayCompleted}/{todayTotal}. Just one more.",
        "Streak: {streakDays} days. Keep adding.",
        "Do the minimum viable action today.",
        "A small habit beats big motivation.",
        "Don't chase epic: chase consistent."
      ]
    }
  },

  LOW_LEVEL: {
    headlines: {
      es: [
        "Empieza simple. Empieza hoy.",
        "Un paso pequeño ya es avance.",
        "Hazlo fácil. Hazlo ahora.",
        "Solo necesitas empezar.",
        "Cero presión: una acción.",
        "La constancia nace hoy.",
        "Hoy es buen día para arrancar.",
        "Pequeño inicio, gran cambio.",
        "Una cosa. Solo una.",
        "Arranca con lo más fácil."
      ],
      en: [
        "Start simple. Start today.",
        "One small step is progress.",
        "Make it easy. Do it now.",
        "You only need to start.",
        "No pressure: one action.",
        "Consistency starts today.",
        "Today is a great day to begin.",
        "Small start, big change.",
        "One thing. Just one.",
        "Begin with the easiest task."
      ]
    },
    sublines: {
      es: [
        "Hoy: {todayCompleted}/{todayTotal}. Con 1 ya ganas.",
        "Hazlo en 2 minutos.",
        "El primer paso rompe la inercia.",
        "Si lo haces fácil, lo haces diario.",
        "Solo una acción y listo."
      ],
      en: [
        "Today: {todayCompleted}/{todayTotal}. One is a win.",
        "Do it in two minutes.",
        "The first step breaks inertia.",
        "If it's easy, it becomes daily.",
        "One action and you're done."
      ]
    }
  },

  COMEBACK: {
    headlines: {
      es: [
        "Vuelve hoy. Dos minutos.",
        "Tu racha te extraña.",
        "Regresa al ritmo.",
        "Retoma con lo más fácil.",
        "No pierdas lo construido.",
        "Hoy se retoma.",
        "Reentrada rápida: 1 acción.",
        "No lo pienses: entra.",
        "Un check-in y sigues.",
        "Vuelve a tu estándar."
      ],
      en: [
        "Come back today. Two minutes.",
        "Your streak misses you.",
        "Return to your rhythm.",
        "Restart with the easiest task.",
        "Don't lose what you built.",
        "Today is the comeback.",
        "Quick re-entry: one action.",
        "Don't overthink it: open the app.",
        "One check-in and you're back.",
        "Return to your standard."
      ]
    },
    sublines: {
      es: [
        "Llevas {hoursSinceLastOpen}h fuera. Entra 2 minutos.",
        "Racha actual: {streakDays} días. No la rompas.",
        "Hoy: solo 1 acción para retomar.",
        "Vuelve y elige la tarea más fácil.",
        "Pequeña victoria hoy = regreso completo."
      ],
      en: [
        "It's been {hoursSinceLastOpen}h. Two minutes is enough.",
        "Current streak: {streakDays} days. Don't break it.",
        "Today: just one action to return.",
        "Open the app and pick the easiest task.",
        "A small win today = full comeback."
      ]
    }
  }
}

// Push notification message banks
const NOTIFICATION_BANKS = {
  NOTIF_24H: {
    es: [
      "¿Dos minutos para mantener tu racha viva?",
      "Un check-in rápido mantiene el momentum.",
      "Hoy cuenta: entra 2 minutos.",
      "Ritmo suave, racha fuerte. Entra.",
      "Solo una acción y sigues arriba."
    ],
    en: [
      "Two minutes to keep your streak alive?",
      "A quick check-in keeps momentum.",
      "Today matters: open for two minutes.",
      "Easy rhythm, strong streak. Jump in.",
      "One action and you're back on top."
    ]
  },
  NOTIF_48H: {
    es: [
      "Tu ritmo se está yendo. Vuelve hoy.",
      "Racha en riesgo. No la rompas.",
      "Estás a tiempo: una acción y listo.",
      "No pierdas momentum. Entra ahora.",
      "Regresa y haz lo más fácil."
    ],
    en: [
      "Your rhythm is slipping. Come back today.",
      "Streak at risk. Don't break it.",
      "Still on time: one action and done.",
      "Don't lose momentum. Open now.",
      "Come back and do the easiest task."
    ]
  },
  NOTIF_72H: {
    es: [
      "No pierdas lo construido. Retoma hoy.",
      "Reentrada: elige una tarea fácil y listo.",
      "Dos minutos hoy te devuelven al camino.",
      "Vuelve. Empieza con lo mínimo.",
      "Hoy se retoma. Sin drama."
    ],
    en: [
      "Don't lose what you built. Come back today.",
      "Re-entry: pick an easy task and you're done.",
      "Two minutes today puts you back on track.",
      "Come back. Start with the minimum.",
      "Today is the comeback. No drama."
    ]
  },
  NOTIF_SMART: {
    es: [
      "Racha: {streakDays} días. No la rompas hoy.",
      "Llevas {hoursSinceLastOpen}h fuera. Vuelve 2 minutos.",
      "Te faltan {daysToRecord} días para tu récord. Entra hoy."
    ],
    en: [
      "Streak: {streakDays} days. Don't break it today.",
      "It's been {hoursSinceLastOpen}h. Two-minute comeback.",
      "You're {daysToRecord} days from your record. Open today."
    ]
  }
}

// Cache for last shown messages to avoid repetition
let lastShownHeadline = null
let lastShownSubline = null

/**
 * Determines the message group based on user context
 */
function determineMessageGroup(context) {
  const { userLevelScore, hoursSinceLastOpen } = context
  
  // COMEBACK overrides others when inactive >= 24h
  if (hoursSinceLastOpen >= 24) {
    return 'COMEBACK'
  }
  
  // Level-based groups
  if (userLevelScore >= 100) return 'MAX_LEVEL'
  if (userLevelScore >= 80) return 'HIGH_LEVEL'
  if (userLevelScore >= 40) return 'MID_LEVEL'
  return 'LOW_LEVEL'
}

/**
 * Replaces template variables with actual values
 */
function interpolateTemplate(template, variables) {
  if (!template) return ''
  
  let result = template
  Object.entries(variables).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      result = result.replace(new RegExp(`\\{${key}\\}`, 'g'), String(value))
    }
  })
  
  // Remove any remaining unreplaced variables
  result = result.replace(/\{[^}]+\}/g, '')
  
  return result.trim()
}

/**
 * Selects a random message avoiding the last shown one
 */
function selectRandomMessage(messages, lastShown) {
  if (!messages || messages.length === 0) return null
  if (messages.length === 1) return messages[0]
  
  let available = messages.filter(m => m !== lastShown)
  if (available.length === 0) available = messages
  
  return available[Math.floor(Math.random() * available.length)]
}

/**
 * Filters sublines to only include those with available variables
 */
function filterValidSublines(sublines, variables) {
  return sublines.filter(subline => {
    const requiredVars = subline.match(/\{([^}]+)\}/g) || []
    return requiredVars.every(varMatch => {
      const varName = varMatch.slice(1, -1)
      return variables[varName] !== undefined && variables[varName] !== null
    })
  })
}

/**
 * Main Microcopy Engine function
 * 
 * @param {Object} context - User context
 * @param {number} context.userLevelScore - User's level score (0-100)
 * @param {number} context.streakDays - Current streak in days
 * @param {number} context.hoursSinceLastOpen - Hours since last app open
 * @param {number} context.todayCompleted - Tasks completed today
 * @param {number} context.todayTotal - Total tasks for today
 * @param {number} context.daysToRecord - Days to beat personal record
 * @param {string} locale - 'es' or 'en'
 * @returns {Object} { headline, subline, group }
 */
export function getMicrocopy(context, locale = 'es') {
  const {
    userLevelScore = 0,
    streakDays = 0,
    hoursSinceLastOpen = 0,
    todayCompleted = 0,
    todayTotal = 0,
    daysToRecord = null
  } = context
  
  // Normalize locale
  const lang = locale.startsWith('es') ? 'es' : 'en'
  
  // Determine message group
  const group = determineMessageGroup({ userLevelScore, hoursSinceLastOpen })
  
  // Get the bank for this group
  const bank = SENTENCE_BANKS[group]
  if (!bank) {
    return { headline: '', subline: '', group: 'UNKNOWN' }
  }
  
  // Select headline
  const headlines = bank.headlines[lang] || bank.headlines.es
  const headline = selectRandomMessage(headlines, lastShownHeadline)
  lastShownHeadline = headline
  
  // Prepare variables for sublines
  const variables = {
    streakDays,
    hoursSinceLastOpen: Math.round(hoursSinceLastOpen),
    todayCompleted,
    todayTotal,
    daysToRecord
  }
  
  // Select subline
  let subline = ''
  
  // If todayTotal is 0, don't show progress messaging - use streak/maintenance messaging
  const sublines = bank.sublines[lang] || bank.sublines.es
  let validSublines = filterValidSublines(sublines, variables)
  
  // If todayTotal is 0, filter out progress-specific sublines
  if (todayTotal === 0) {
    validSublines = validSublines.filter(s => !s.includes('{todayCompleted}'))
  }
  
  if (validSublines.length > 0) {
    const selectedSubline = selectRandomMessage(validSublines, lastShownSubline)
    lastShownSubline = selectedSubline
    subline = interpolateTemplate(selectedSubline, variables)
  }
  
  return { headline, subline, group }
}

/**
 * Get notification message for push notifications
 * 
 * @param {string} tier - 'NOTIF_24H', 'NOTIF_48H', 'NOTIF_72H', or 'NOTIF_SMART'
 * @param {string} locale - 'es' or 'en'
 * @param {Object} variables - Variables for smart notifications
 * @returns {string} Notification message
 */
export function getNotificationMessage(tier, locale = 'es', variables = {}) {
  const lang = locale.startsWith('es') ? 'es' : 'en'
  const bank = NOTIFICATION_BANKS[tier]
  
  if (!bank) return ''
  
  const messages = bank[lang] || bank.es
  
  if (tier === 'NOTIF_SMART') {
    // Filter to only include messages with available variables
    const validMessages = filterValidSublines(messages, variables)
    if (validMessages.length === 0) return ''
    const selected = selectRandomMessage(validMessages, null)
    return interpolateTemplate(selected, variables)
  }
  
  return selectRandomMessage(messages, null)
}

/**
 * Determine which notification tier to use based on hours since last open
 * 
 * @param {number} hoursSinceLastOpen
 * @returns {string|null} Notification tier or null if no notification needed
 */
export function getNotificationTier(hoursSinceLastOpen) {
  if (hoursSinceLastOpen >= 72) return 'NOTIF_72H'
  if (hoursSinceLastOpen >= 48) return 'NOTIF_48H'
  if (hoursSinceLastOpen >= 24) return 'NOTIF_24H'
  return null
}

// Export banks for direct access if needed
export { SENTENCE_BANKS, NOTIFICATION_BANKS }
